export default "__VITE_ASSET__nWPoJlj5__"